// The two video sizes an export can have (portrait). The client draws at this size; the server checks it.
export const EXPORT_SIZES = [
  { id: "720p", name: "720p", hint: "Faster", w: 720, h: 1280, batch: 12 },
  { id: "1080p", name: "1080p", hint: "Sharper", w: 1080, h: 1920, batch: 6 },
] as const;
export type ExportSize = (typeof EXPORT_SIZES)[number];
export const DEFAULT_EXPORT_SIZE: ExportSize = EXPORT_SIZES[1];
export const exportSizeById = (id: unknown) => EXPORT_SIZES.find(s => s.id === id);
